import { makeStyles, createStyles } from '@material-ui/core/styles';

export const LoaderStyles = makeStyles(() =>
  createStyles({
    'load-container': {
      backgroundColor: '#ECF0F1',
      width: '100%',
      height: '100vh',
      position: 'fixed',
      zIndex: "revert"
    },
    'load':{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '5rem',
      height: '5rem',
    }
  }),
);